import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter as Router } from '@react-router';
import { loadableReady } from '@loadable/component';
import { useSSR } from 'react-i18next';
import { ErrorBoundary } from './ErrorBoundary';
import globalWindow from '@shared/core/globals';
import App from './App';
import '@shared/core/i18n/i18n';
import { FullPageLoaderProvider } from '@shared/components/JoyLogoLoader/FullPageLoaderProvider';

const BaseApp: React.FC = props => {
  useSSR(globalWindow.__INITIAL_I18N_STORE__, globalWindow.__INITIAL_I18N_LANG__);

  return (
    <ErrorBoundary>
      <FullPageLoaderProvider>
        <Router>
          <App
            {...props}
            defaultScreen={globalWindow.__INITIAL_DEVICE_SCREEN__}
          />
        </Router>
      </FullPageLoaderProvider>
    </ErrorBoundary>
  );
};

// Wait for all scripts to load asynchronously
loadableReady(() => {
  const root = document.getElementById('root');
  hydrate(<BaseApp />, root);
  // Signal the hydration watchdog that React is alive. This flips the
  // watchdog's internal hydrated flag and cancels the ?retry=page
  // auto-redirect timer set in <head>. Undefined on retry pages (the
  // watchdog isn't injected there), hence the optional call.
  window.__JOY_CANCEL_WATCHDOG__?.();
});

if (process.env.NODE_ENV === 'development') {
  module.hot?.accept();
}
